module.exports = __webpack_public_path__ + "static/media/purple_temp.13ac1a77.svg";